export default "__VITE_ASSET__CTDzYiHN__"